import { render, staticRenderFns } from "./ResultSurvey.vue?vue&type=template&id=090b480b"
import script from "./ResultSurvey.vue?vue&type=script&lang=js"
export * from "./ResultSurvey.vue?vue&type=script&lang=js"
import style0 from "./ResultSurvey.vue?vue&type=style&index=0&id=090b480b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports